// @ts-ignore
import { GandalfArray } from 'gandalf';
// @ts-ignore
import { GandalfConstantDecorator } from 'gandalf';
// @ts-ignore
import { GandalfLabel } from 'gandalf';
// @ts-ignore
import { GandalfModel } from 'gandalf';
// @ts-ignore
import { GandalfModelBase } from 'gandalf';
// @ts-ignore
import { GandalfProperty } from 'gandalf';
// @ts-ignore
import { GandalfSubRequestLabel } from 'gandalf';
// @ts-ignore
import { GandalfValidator } from 'gandalf';
// @ts-ignore
import * as constants from '../constants';


/** See com.rev360.pms.api.controller.accounting.AddInvoiceItemRequest */
/* istanbul ignore next */
@GandalfModel
export class AddInvoiceItemRequest extends GandalfModelBase {

	@GandalfValidator({ notNull: { message: 'Invoice is required' } })
	@GandalfProperty({ designType: Number, isRequired: true })
	invoiceId!: number;

	@GandalfConstantDecorator(constants.InvoiceItemType)
	@GandalfValidator({ notNull: { message: 'Item type is required' } })
	@GandalfProperty({ designType: constants.InvoiceItemType, isRequired: true })
	itemType!: constants.InvoiceItemType;

	@GandalfProperty({ designType: Number })
	locationProductId!: number | null;

	@GandalfProperty({ designType: Number })
	locationProductItemId!: number | null;

	@GandalfValidator({ notNull: { message: 'Item quantity is required' } })
	@GandalfValidator({ min: { min: 1, message: 'Quantity must be at least {min}' } })
	@GandalfProperty({ designType: Number, isRequired: true })
	quantity!: number;

	@GandalfProperty({ designType: Number })
	serviceId!: number | null;

}
